import { render, staticRenderFns } from "./DetailForm.vue?vue&type=template&id=4b10e128&"
import script from "./DetailForm.vue?vue&type=script&lang=js&"
export * from "./DetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/azureuser/wnytoys/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b10e128')) {
      api.createRecord('4b10e128', component.options)
    } else {
      api.reload('4b10e128', component.options)
    }
    module.hot.accept("./DetailForm.vue?vue&type=template&id=4b10e128&", function () {
      api.rerender('4b10e128', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client/app/components/account/DetailForm.vue"
export default component.exports